/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */

/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/video-exercise/v1.ts
 */
import { createValidator } from '../../helpers/validator';
export var VideoExerciseV1Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    video: {
      type: 'object',
      properties: {
        projector_key: {
          type: 'string'
        },
        video_hls: {
          type: 'string'
        },
        video_link: {
          type: 'string'
        }
      }
    }
  },
  required: ['chapter_id', 'course_id', 'title', 'video', 'xp'],
  definitions: {}
};
export var isValidVideoExerciseV1 = createValidator(VideoExerciseV1Schema);
export var VideoExerciseV1Definition = {
  schema: VideoExerciseV1Schema,
  validate: isValidVideoExerciseV1
};